module.exports = __webpack_public_path__ + "img/img21.e29c2847.png";